/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { AuthorizedAppRequest } from '../models';
// @ts-ignore
import { AuthorizedAppResponse } from '../models';
// @ts-ignore
import { AuthorizedAppUpdateRequest } from '../models';
/**
 * AuthorizedAppsApi - axios parameter creator
 * @export
 */
export const AuthorizedAppsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary grant App to an Admin
         * @param {string} gamixAppId 
         * @param {string} admin 
         * @param {AuthorizedAppRequest} authorizedAppRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizedAppsControllerCreate: async (gamixAppId: string, admin: string, authorizedAppRequest: AuthorizedAppRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('authorizedAppsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'admin' is not null or undefined
            assertParamExists('authorizedAppsControllerCreate', 'admin', admin)
            // verify required parameter 'authorizedAppRequest' is not null or undefined
            assertParamExists('authorizedAppsControllerCreate', 'authorizedAppRequest', authorizedAppRequest)
            const localVarPath = `/v2/authorized-apps/{admin}/grant`
                .replace(`{${"admin"}}`, encodeURIComponent(String(admin)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizedAppRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Grant coreleads access to the current admin
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizedAppsControllerGrantCoreLeadsAccess: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('authorizedAppsControllerGrantCoreLeadsAccess', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/authorized-apps/grant-coreleads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update admin\'s app role
         * @param {string} gamixAppId 
         * @param {string} admin 
         * @param {AuthorizedAppUpdateRequest} authorizedAppUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizedAppsControllerUpdate: async (gamixAppId: string, admin: string, authorizedAppUpdateRequest: AuthorizedAppUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('authorizedAppsControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'admin' is not null or undefined
            assertParamExists('authorizedAppsControllerUpdate', 'admin', admin)
            // verify required parameter 'authorizedAppUpdateRequest' is not null or undefined
            assertParamExists('authorizedAppsControllerUpdate', 'authorizedAppUpdateRequest', authorizedAppUpdateRequest)
            const localVarPath = `/v2/authorized-apps/{admin}`
                .replace(`{${"admin"}}`, encodeURIComponent(String(admin)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizedAppUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthorizedAppsApi - functional programming interface
 * @export
 */
export const AuthorizedAppsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthorizedAppsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary grant App to an Admin
         * @param {string} gamixAppId 
         * @param {string} admin 
         * @param {AuthorizedAppRequest} authorizedAppRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizedAppsControllerCreate(gamixAppId: string, admin: string, authorizedAppRequest: AuthorizedAppRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedAppResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizedAppsControllerCreate(gamixAppId, admin, authorizedAppRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizedAppsApi.authorizedAppsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Grant coreleads access to the current admin
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizedAppsControllerGrantCoreLeadsAccess(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedAppResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizedAppsControllerGrantCoreLeadsAccess(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizedAppsApi.authorizedAppsControllerGrantCoreLeadsAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update admin\'s app role
         * @param {string} gamixAppId 
         * @param {string} admin 
         * @param {AuthorizedAppUpdateRequest} authorizedAppUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizedAppsControllerUpdate(gamixAppId: string, admin: string, authorizedAppUpdateRequest: AuthorizedAppUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedAppResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizedAppsControllerUpdate(gamixAppId, admin, authorizedAppUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizedAppsApi.authorizedAppsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthorizedAppsApi - factory interface
 * @export
 */
export const AuthorizedAppsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthorizedAppsApiFp(configuration)
    return {
        /**
         * 
         * @summary grant App to an Admin
         * @param {AuthorizedAppsApiAuthorizedAppsControllerCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizedAppsControllerCreate(requestParameters: AuthorizedAppsApiAuthorizedAppsControllerCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthorizedAppResponse> {
            return localVarFp.authorizedAppsControllerCreate(requestParameters.gamixAppId, requestParameters.admin, requestParameters.authorizedAppRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Grant coreleads access to the current admin
         * @param {AuthorizedAppsApiAuthorizedAppsControllerGrantCoreLeadsAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizedAppsControllerGrantCoreLeadsAccess(requestParameters: AuthorizedAppsApiAuthorizedAppsControllerGrantCoreLeadsAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthorizedAppResponse> {
            return localVarFp.authorizedAppsControllerGrantCoreLeadsAccess(requestParameters.gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update admin\'s app role
         * @param {AuthorizedAppsApiAuthorizedAppsControllerUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizedAppsControllerUpdate(requestParameters: AuthorizedAppsApiAuthorizedAppsControllerUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthorizedAppResponse> {
            return localVarFp.authorizedAppsControllerUpdate(requestParameters.gamixAppId, requestParameters.admin, requestParameters.authorizedAppUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for authorizedAppsControllerCreate operation in AuthorizedAppsApi.
 * @export
 * @interface AuthorizedAppsApiAuthorizedAppsControllerCreateRequest
 */
export interface AuthorizedAppsApiAuthorizedAppsControllerCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppsApiAuthorizedAppsControllerCreate
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppsApiAuthorizedAppsControllerCreate
     */
    readonly admin: string

    /**
     * 
     * @type {AuthorizedAppRequest}
     * @memberof AuthorizedAppsApiAuthorizedAppsControllerCreate
     */
    readonly authorizedAppRequest: AuthorizedAppRequest
}

/**
 * Request parameters for authorizedAppsControllerGrantCoreLeadsAccess operation in AuthorizedAppsApi.
 * @export
 * @interface AuthorizedAppsApiAuthorizedAppsControllerGrantCoreLeadsAccessRequest
 */
export interface AuthorizedAppsApiAuthorizedAppsControllerGrantCoreLeadsAccessRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppsApiAuthorizedAppsControllerGrantCoreLeadsAccess
     */
    readonly gamixAppId: string
}

/**
 * Request parameters for authorizedAppsControllerUpdate operation in AuthorizedAppsApi.
 * @export
 * @interface AuthorizedAppsApiAuthorizedAppsControllerUpdateRequest
 */
export interface AuthorizedAppsApiAuthorizedAppsControllerUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppsApiAuthorizedAppsControllerUpdate
     */
    readonly gamixAppId: string

    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppsApiAuthorizedAppsControllerUpdate
     */
    readonly admin: string

    /**
     * 
     * @type {AuthorizedAppUpdateRequest}
     * @memberof AuthorizedAppsApiAuthorizedAppsControllerUpdate
     */
    readonly authorizedAppUpdateRequest: AuthorizedAppUpdateRequest
}

/**
 * AuthorizedAppsApi - object-oriented interface
 * @export
 * @class AuthorizedAppsApi
 * @extends {BaseAPI}
 */
export class AuthorizedAppsApi extends BaseAPI {
    /**
     * 
     * @summary grant App to an Admin
     * @param {AuthorizedAppsApiAuthorizedAppsControllerCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizedAppsApi
     */
    public authorizedAppsControllerCreate(requestParameters: AuthorizedAppsApiAuthorizedAppsControllerCreateRequest, options?: RawAxiosRequestConfig) {
        return AuthorizedAppsApiFp(this.configuration).authorizedAppsControllerCreate(requestParameters.gamixAppId, requestParameters.admin, requestParameters.authorizedAppRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Grant coreleads access to the current admin
     * @param {AuthorizedAppsApiAuthorizedAppsControllerGrantCoreLeadsAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizedAppsApi
     */
    public authorizedAppsControllerGrantCoreLeadsAccess(requestParameters: AuthorizedAppsApiAuthorizedAppsControllerGrantCoreLeadsAccessRequest, options?: RawAxiosRequestConfig) {
        return AuthorizedAppsApiFp(this.configuration).authorizedAppsControllerGrantCoreLeadsAccess(requestParameters.gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update admin\'s app role
     * @param {AuthorizedAppsApiAuthorizedAppsControllerUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizedAppsApi
     */
    public authorizedAppsControllerUpdate(requestParameters: AuthorizedAppsApiAuthorizedAppsControllerUpdateRequest, options?: RawAxiosRequestConfig) {
        return AuthorizedAppsApiFp(this.configuration).authorizedAppsControllerUpdate(requestParameters.gamixAppId, requestParameters.admin, requestParameters.authorizedAppUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

